import { render } from "./component-egrul-data-subtitle.vue?vue&type=template&id=c72c64de"
import script from "./component-egrul-data-subtitle.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-data-subtitle.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-data-subtitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c72c64de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c72c64de', __exports__)) {
    api.reload('c72c64de', __exports__)
  }
  
  module.hot.accept("./component-egrul-data-subtitle.vue?vue&type=template&id=c72c64de", () => {
    api.rerender('c72c64de', render)
  })

}


export default __exports__